export default __webpack_public_path__ + "static/media/joindiscord.9ef1e01d.png";